import Button from '../components/Button';
import content from '../data/content';
import PageMeta from '../components/PageMeta';
import './NotFound.css';

function NotFound() {
  const copy = content.notFound;

  return (
    <>
      <PageMeta
        title={copy.metaTitle}
        description={copy.metaDescription}
      />

      <section className="notfound">
        <div className="container">
          <div className="notfound__inner">
            <p className="notfound__code">404</p>
            <h1 className="notfound__title">{copy.title}</h1>
            <p className="notfound__text">{copy.description}</p>
            <div className="notfound__actions">
              <Button to="/">{copy.homeButton}</Button>
              <Button to="/projects" variant="ghost">
                {copy.projectsButton}
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NotFound;
